import { api } from "@/lib/api";

export interface TodayStats {
  totalBookings: number;
  bookingsByType: {
    online: number;
    offline: number;
    subscription: number;
  };
  statusCounts: {
    completed: number;
    assigned: number;
    inProgress: number;
    notCompleted: number;
    postponed: number;
    cancelled: number;
    pending: number;
    confirmed: number;
  };
}

export interface CashByTeam {
  staffId: string;
  staffName: string;
  orders: number;
  amount: number;
}

export interface MonthlySalesData {
  date: string;
  count: number;
  revenue: number;
}

export interface TodayRevenue {
  collected: number;
  pending: number;
  totalExpected: number;
}

interface ApiResponse<T> {
  status: string;
  message: string;
  data: T;
}

export const dashboardService = {
  async getTodayStats(): Promise<TodayStats> {
    try {
      const response = await api.get<ApiResponse<TodayStats>>("/dashboard/today-stats");
      return response.data.data;
    } catch (error) {
      console.error("Error fetching today's stats:", error);
      throw error;
    }
  },

  async getCashByTeam(): Promise<CashByTeam[]> {
    try {
      const response = await api.get<ApiResponse<CashByTeam[]>>("/dashboard/cash-by-team");
      return response.data.data;
    } catch (error) {
      console.error("Error fetching cash by team:", error);
      throw error;
    }
  },

  async getMonthlySales(period: "weekly" | "monthly" = "monthly"): Promise<MonthlySalesData[]> {
    try {
      const response = await api.get<ApiResponse<MonthlySalesData[]>>(
        `/dashboard/monthly-sales?period=${period}`
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching monthly sales:", error);
      throw error;
    }
  },

  async getTodayRevenue(): Promise<TodayRevenue> {
    try {
      const response = await api.get<ApiResponse<TodayRevenue>>("/dashboard/today-revenue");
      return response.data.data;
    } catch (error) {
      console.error("Error fetching today's revenue:", error);
      throw error;
    }
  },
};
